import { Navigate } from 'react-router-dom';
import { Login } from '../features/auth/pages/Login';
import { Register } from "../features/auth/components/Register";
import SurveyForm from "../features/survey/page/SurveyForm";
import MainLayout from "../components/Layouts/MainLayout";

type PrivateRouteProps = {
  children: React.ReactNode;
};

const AuthRoute: React.FC<PrivateRouteProps> = ({ children }) => {
  const token = localStorage.getItem('token');
    console.log("AuthRoute");
  if (token) {
      return <Navigate to="/pending-surveys" />;
  }

  return <>{children}</>;
};

export const publicRoutes = [
  {
    path: '/',
    element: <MainLayout />,
    children: [
      { path: 'surveys/:surveyId', element: <SurveyForm /> },
    ],
  },
  {
    path: '/login',
    element: (
      <AuthRoute>
        <Login />
      </AuthRoute>
    ),
    }, {
        path: '/register', element: <Register />
    },
    { path: '/', element: <Navigate to="/pending-surveys" replace /> },
    { path: '/*', element: <Navigate to="/pending-surveys" replace /> },
];
